import CheckEligiblityMemberDetail from 'components/MemberDetail/CheckSubmitMemberDetail.component';

const CheckMemberDetail = () => {
	return <CheckEligiblityMemberDetail />;
};

export default CheckMemberDetail;
